import { getLocale } from "../runtime";

const sv_eecountryenglish = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Estonia`
};

const eecountryenglish = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_eecountryenglish(inputs)
	return "eeCountryEnglish";
};

export { eecountryenglish as "eeCountryEnglish" };